"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get RecurrenceModel () {
        return RecurrenceModel;
    },
    get RecurringSeriesModel () {
        return RecurringSeriesModel;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../meetings-integrations/base");
const _base1 = require("./base");
const RecurrenceModel = _zod.z.object({
    frequency: _models.RecurrenceFrequencySchema,
    interval: _zod.z.number().int().min(1).max(4),
    dayOfWeek: _models.RecurrenceDayOfWeekSchema,
    weekOfMonth: _models.RecurrenceWeekOfMonthSchema.optional()
});
const RecurringSeriesModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    meetingWorkspaceId: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    description: _zod.z.string(),
    status: _models.MeetingRecurringSeriesStatusSchema,
    recurrence: RecurrenceModel,
    timezone: _zod.z.string(),
    startTimeOfDay: _zod.z.string(),
    durationMinutes: _zod.z.number().int().positive(),
    seriesStartDate: _utilsisomorphic.transformDate,
    seriesEndDate: _utilsisomorphic.transformDate.optional(),
    carryOver: _zod.z.boolean(),
    integrationOwnerId: _utilsisomorphic.transformObjectId,
    addToCalendar: _zod.z.boolean(),
    /** Whether a native recurring event exists on the owner's calendar. */ hasCalendarSeries: _zod.z.boolean(),
    videoConferencingProvider: _base.VideoConferencingProviderEnum.optional(),
    currentMeetingId: _utilsisomorphic.transformObjectId.optional(),
    nextOccurrenceAt: _utilsisomorphic.transformDate,
    /** Human-readable cadence, e.g. "Every 2 weeks on Tuesday". */ recurrenceLabel: _zod.z.string(),
    created: _base1.UserActionRecord,
    updated: _base1.UserActionRecord
});
